module.exports = __webpack_public_path__ + "media/images/icons/smp_hero-e88a50a412a90a85e4578c8db9ee97ea.svg";